import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AbAdminRecado } from 'app/abstract/full-pages/admin-recados/admin-recado.abstract';
import { AdminRecadoDTO } from 'app/models/admin-recado-dto.model';
import { AppFilter } from 'app/models/app-filter.model';
import { Pageable } from 'app/models/pageable-mode';
import { AuthService } from 'app/shared/auth/auth.service';
import { DataUtils } from 'app/utils/data.utils';

@Injectable({
  providedIn: 'root',
})
export class AdminRecadoService extends AbAdminRecado {
  constructor(
    http: HttpClient,
    private authService: AuthService,
    private dateUtils: DataUtils,
    private translate: TranslateService,
  ) {
    super(http);
  }

  getAllRecadosInicio(filter: AppFilter): Observable<Pageable<AdminRecadoDTO>> {
    const locale = (this.authService.getLocale() || '').replace('_', '-');
    const endPoint = 'admin/v1/recados/dashboard/';
    const filterEncode = filter.encode();

    return this.getAll(endPoint, filterEncode).pipe(
      map((res: AdminRecadoDTO[]) => {
        const response = new Pageable<AdminRecadoDTO>();
        response.content = res.map((item) => ({
          ...item,
          dataCadastro: this.dateUtils.formatarData(new Date(item.dataCadastro), locale),
          destinatarios: this.translate.instant(item.destinatarios),
        }));
        response.first = true;
        response.last = false;
        response.number = 10;
        response.numberOfElements = 10;
        response.pageable = null;
        response.size = 10;
        response.sort = null;
        response.totalElements = res.length;
        response.totalPages = 10;

        return response;
      })
    ) as Observable<Pageable<AdminRecadoDTO>>;
  }
}
